import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { GruposApi } from '../api/grupos.api';
import { IGrupoDTO } from '../dto/grupo-dto';
import { IGrupo } from '../models/grupo';

@Injectable()
export class GruposService extends ServiceBase<IGrupo, IGrupoDTO> {

    constructor(private api: GruposApi) {
        super(api);
    }
}
